import { default as CompanyName } from '../_internal/components/CompanyName';
export default CompanyName;